import { useTranslation } from '@/i18n/useTranslation';

import { useState, type FormEvent } from 'react';
import { apiClient } from '@/api/client';
import { useAuth } from '@/auth/useAuth';

export function ProfilePage() {
  const { t } = useTranslation();
  const { currentUser, logout } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState(false);
  const [pending, setPending] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setPending(true);
    setError(false);
    try {
      await apiClient.post('/auth/change-password', {
        current_password: currentPassword,
        new_password: newPassword,
      });
      logout();
    } catch {
      setError(true);
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="stack">
      <h1>{t('My account')}</h1>
      <p>
        {currentUser?.display_name} · {currentUser?.username || currentUser?.email}
      </p>
      {currentUser?.must_change_password && (
        <p role="alert">{t('Change your initial password before continuing.')}</p>
      )}
      <section className="glass-panel stack">
        <h2>{t('Change password')}</h2>
        <form className="stack" onSubmit={(event) => void submit(event)}>
          <label className="field">
            <span className="field__label">{t('Current password')}</span>
            <input
              className="input"
              type="password"
              autoComplete="current-password"
              required
              value={currentPassword}
              onChange={(event) => setCurrentPassword(event.target.value)}
            />
          </label>
          <label className="field">
            <span className="field__label">{t('New password')}</span>
            <input
              className="input"
              type="password"
              autoComplete="new-password"
              minLength={12}
              required
              value={newPassword}
              onChange={(event) => setNewPassword(event.target.value)}
            />
          </label>
          {error && (
            <p role="alert">
              {t(
                'Could not change your password. Check the current password and use a different new password of at least 12 characters.',
              )}
            </p>
          )}
          <button className="btn btn--primary" type="submit" disabled={pending}>
            {t('Change password')}
          </button>
        </form>
      </section>
    </div>
  );
}
